import Swal from 'sweetalert2'
import PurchasePlanPublishLimitDialog from '@/components/modals/purchase-plan-publish-limit-dialog.vue'

export default {
  components: {
    PurchasePlanPublishLimitDialog,
  },
  data() {
    return {
      lastPurchasePlanSubmitAction: null,
    }
  },
  methods: {
    purchasePlanSubmitId() {
      const id = this.$route.params.key
        || (this.model && this.model.id)
        || ''

      return `${id}`.trim()
    },
    isPurchasePlanLimitExceededError(error) {
      if (!error || !error.response || error.response.status !== 422) return false
      if (this.lastPurchasePlanSubmitAction !== 'publish') return false

      const errors = (error.response.data || {}).errors || {}
      return Array.isArray(errors.estimated_amount) && errors.estimated_amount.length > 0
    },
    failedAlert(error) {
      const response = (error && error.response) || {}
      const isValidationError = response.status === 422

      if (isValidationError) {
        this.errors = (response.data || {}).errors || {}
      }

      if (this.isPurchasePlanLimitExceededError(error) && this.$refs.purchasePlanPublishLimitDialog) {
        return this.$refs.purchasePlanPublishLimitDialog.show(this.purchasePlanSubmitId())
      }

      const fallbackMessage = (response.data || {}).message || (error && error.message)

      if (isValidationError) {
        const key = Object.keys(this.errors).find((k) => (this.errors[k] || []).length)
        const firstError = key && this.errors[key][0]
        return Swal.fire({
          title: this.$t('Failed') + '!',
          text: firstError || fallbackMessage,
          type: 'danger',
          confirmButtonClass: 'btn btn-danger btn-fill',
          buttonsStyling: false,
        })
      }

      return Swal.fire({
        title: this.$t('Failed') + '!',
        text: fallbackMessage,
        type: 'danger',
        confirmButtonClass: 'btn btn-danger btn-fill',
        buttonsStyling: false,
      })
    },
  },
}
